import shopifyChromiumGenericV4Defaults from '../shopify-chromium-generic-v4/config.js';

export default {
  ...shopifyChromiumGenericV4Defaults,
  includes: ['shopify-chromium-generic-v4'],
};
